import React from 'react';
import { useSelector } from 'react-redux';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { Tooltip } from '@mm/components';
import { ReactComponent as AccountIcon } from '../../../../../../../../layout/BotBuilderSidebar/UserDropdown/UserDropdownIcons/UserFallback.svg';
import {
  LinkOutlined,
  QuestionCircleOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { selectCrmsLeadsSent } from '@mm/state/selectors/connectionsSelectors';
import { HelpCenter } from '../../../../../../../../common/components/HelpCenter/HelpCenter';

type Props = {
  isAccountConnected: boolean;
  mailchimpCount?: number;
  accountsCount?: number;
  onConnect: () => void;
  className?: string;
};

export const MailchimpHeaderComponent = (props: Props) => {
  const {
    isAccountConnected,
    mailchimpCount,
    accountsCount,
    onConnect,
    className,
  } = props;

  const crmsLeadsSent = useSelector(selectCrmsLeadsSent);
  const leadsSent = crmsLeadsSent?.mailchimpContactsSent;

  return (
    <div className={className}>
      <div className="integrations__header-actions">
        <HelpCenter
          helpLink="https://customers.ai/help/l/en/article/1a56f1gfmn-integration-with-mailchimp"
          title=""
          icon={<QuestionCircleOutlined style={{ fontSize: 20 }} />}
        />
        <Tooltip
          placement="bottom"
          title="Mailchimp Accounts used in connections"
        >
          {!!accountsCount && (
            <div className="integrations__header-status">
              <AccountIcon className="integrations__header-status-icon" />
              <div className="integrations__header-status-count">
                {accountsCount}
              </div>
              Accounts
            </div>
          )}
        </Tooltip>
        {isAccountConnected && (
          <>
            <div className="integrations__header-status">
              <LinkOutlined className="integrations__header-status-icon" />
              <div className="integrations__header-status-count">
                {mailchimpCount}
              </div>
              Connections
            </div>

            {!!leadsSent && (
              <div className="integrations__header-status">
                <TeamOutlined className="integrations__header-status-icon" />
                <div className="integrations__header-status-count">
                  {leadsSent}
                </div>
                Leads sent
              </div>
            )}

            <PrimaryButton
              className="integrations__header-add-button-secondary"
              onClick={e => {
                e?.stopPropagation();
                onConnect();
              }}
              color={ButtonColor.secondaryBlue}
            >
              Add an Account
            </PrimaryButton>
          </>
        )}
      </div>
    </div>
  );
};
